module.exports = __webpack_public_path__ + "static/media/Cooperationbg2.4c447561.png";